import MyAccountButtonContainer from "ui/my_account_button/containers/MyAccountButtonContainer";
import React from "react";

export const ErrorPage = ({children}) => {
    return <div className="container relative mx-auto min-h-screen px-4 py-8 sm:px-6 lg:px-8">
        <div className="flex-1  justify-end flex">
            <MyAccountButtonContainer />
        </div>
        <div className="bg-white py-24 px-6 sm:py-32 lg:px-8">
            <div className="mx-auto max-w-2xl text-center">
                {children}
            </div>
        </div>
    </div>
}